var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3046 13.7656L36.4537 20.7796V34.8125L24.3046 41.8291L12.1504 34.8126V20.7795L24.3046 13.7656ZM12.9129 21.2198V34.3723L24.3046 40.9486L35.6912 34.3724V21.2198L24.3046 14.646L12.9129 21.2198Z",
    fill: "#030621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3061 0.171875L36.2645 7.0809L48.607 14.2049L36.2646 21.3289L24.3061 28.2354L12.3425 21.329L0 14.2049L24.3061 0.171875ZM24.306 1.05244L1.5253 14.2049L12.7237 20.6686L24.306 27.3549L35.8832 20.6687L47.0817 14.2049L35.8833 7.74128L24.306 1.05244Z",
    fill: "#030621"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9258 41.3877V27.7949H24.6883V41.3877H23.9258Z",
    fill: "#030621"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9129 7.41016V20.9979H12.1504V7.41016H12.9129Z",
    fill: "#030621"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4539 7.41016V20.9979H35.6914V7.41016H36.4539Z",
    fill: "#030621"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack2);
export default __webpack_public_path__ + "static/media/logoBlack-2.6cbd4418869225ce431cad42aed884ae.svg";
export { ForwardRef as ReactComponent };